import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'

import { CtaLink } from 'shared/components'

import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

export type BackButtonProps = WithClassName<{
	to: string
	text?: string
	mobile?: boolean
}>

export const BackButton = ({ to, text, className, mobile }: BackButtonProps) => {
	const { t } = useTranslation()

	return (
		<CtaLink
			to={to}
			text={text ?? t('Back')}
			icon={<ArrowLeftIcon />}
			variant="outline"
			compact
			className={cn(className, mobile ? 'lg:hidden' : '')}
		/>
	)
}
